import { FeedsChooser } from "../FeedsChooser";
import { useSearchContext } from "../../contexts";
import { useTranslation } from "react-i18next";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";

interface FeedsChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const FeedsChooserDropdown: React.FC<FeedsChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Feeds")}
      counter={state.draftFilters.feeds.value.length}
      isExclude ={state.draftFilters.feeds.exclude}
      onOpenChange={onOpenChange}
    >
      <FeedsChooser />
    </DropdownFilter>
  )
};
